import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsageAnalyticsList from "../components/report/UsageAnalyticsList";

const UsageAnalyticsReport = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Usage Analytics Report" />

        {/* Usage Analytics List with export functionality */}
        <div className="usage-analytics-report">
          <UsageAnalyticsList />
        </div>
      </MasterLayout>
    </>
  );
};

export default UsageAnalyticsReport;
